// extracted by mini-css-extract-plugin
export default {"wrapper":"shared-components_wrapper__GfVwN","send_button":"shared-components_send_button__XgT4a"};